<template>
    <el-tree class="x-filter-tree" 
        ref="tree"
        default-expand-all
        :expand-on-click-node="false"
        :render-after-expand="true"
        :auto-expand-parent="true"
        :highlight-current="true"
        :show-checkbox="selectType != SelectType.SINGLE_SELECT"
        :check-on-click-node="selectType != SelectType.SINGLE_SELECT"
        :props="{label:config?.nameField}" 
        :node-key="config?.keyField" 
        :data="treeDatas"
        @current-change="selectHandler"
        @check-change="checkHandler"
        >
    </el-tree>
</template>
<script setup>
import { watch, ref, unref, getCurrentInstance } from 'vue';
import SelectType from '../data/SelectType';

const inst = getCurrentInstance();

const treeDatas = ref(null);

const props = defineProps({
    config: { default: null },
    selectType: { default: SelectType.SINGLE_SELECT },
    readonly: { default: false },
    modelValue: { default: null },
    datas: { default: null },
})

const current = ref(null);
const tree = ref(null);
const defaultNode = ref(null);

const getTreeDatas = (datas)=> {
    if (!datas) return [];
    const {keyField, parentField, nameField} = props.config;
    const map = {}
    const root = {};
    const parents = [];
    for (const d of datas) {
        const data = Object.assign({}, d, {children:null});
        const parent = map[data[parentField] || 0];
        if (!parent) {
            const tdata = { children: [data] };
            const parentKey = data[parentField] || 0;
            map[parentKey] = tdata;
            root[parentKey] = tdata;
            parents.push(parentKey);
        } else {
            if (!parent.children) parent.children = [data];
            else parent.children.push(data);
        }
        const m = map[data[keyField]];
        if (m) {
            map[data[keyField]] = Object.assign(data, m);
            delete root[data[keyField]];
        } else map[data[keyField]] = data;
    }
    let items = [];
    for (const p of parents) {
        const data = root[p];
        if (!data) continue;
        if (!data[nameField]) {
            for (const child of data.children) {
                items.push(child);
            }
        } else items.push(data);
    }
    
    if (props.config?.addAll !== false) {
        const allNode = {};
        allNode[keyField] = null;
        allNode[parentField] = -1;
        allNode[nameField] = '全部'
        allNode.level = -1;
        allNode.children = items;
        // items.unshift(allNode);
        items = [allNode];
    }
    if (props.config?.defaultKey && map[props.config?.defaultKey]) {
        defaultNode.value = map[props.config?.defaultKey];
    } else {
        defaultNode.value = items && items.length ? items[0] : null;
    }
    return items;
}

watch(()=> props.datas, (value)=> {
    treeDatas.value = getTreeDatas(value);
}, {immediate:true, deep:true})

watch(()=> props.datas, (value)=> {
    if (defaultNode.value) tree.value?.setCurrentNode(defaultNode.value);
}, {immediate:true})
watch(()=>tree.value, (value)=> {
    if (defaultNode.value) tree.value?.setCurrentNode(defaultNode.value);
})

defineEmits({
    'filter': null
})

const mapData = (data, map)=> {
    if (!map) return null;
    const res = {};
    for (const [targetField, field] of Object.entries(map)) {
        res[targetField] = data[field];
    }
    if (data.children) {
        res.children = data.children.map((child)=> mapData(child, map))
    }
    return res;
}
const fieldsData = (data, fields)=> {
    if (!fields || !fields.length) return null;
    const res = {};
    for (const f of fields) {
        res[f] = data[f];
    }
    if (data.children) {
        res.children = data.children.map((child)=> fieldsData(child, fields))
    }
    return res;
}

const selectHandler = (data)=> {
    const filter = mapData(data, props.config?.filterMap) || fieldsData(data, props.config?.filterFields);
    // if (props.config?.filterMap) {
    //     for (const [targetField, field] of Object.entries(props.config?.filterMap)) {
    //         filter[targetField] = data[field];
    //     }
    // } else if (props.config?.filterFields) {
    //     for (const f of props.config?.filterFields) {
    //         filter[f] = data[f];
    //     }
    // }
    inst.emit('filter', filter);
}
const checkHandler = (data, checked)=> {
    const checkedNodes = tree.value.getCheckedNodes();
    inst.emit('filter', checkedNodes);
}
</script>
<style scoped>
.x-filter-tree {
    margin: 10px 10px 10px 0;
}
</style>